import { cartSession } from '../../bind/order';

export type { CartLineRequest, RejectedCartLine } from '@vs-shop/engine/module/cart/addToCart';
export const {
  pendingCartLinesAtom,
  rejectedCartLinesAtom,
  visiblePendingCartLinesAtom,
  pendingQuantityAtom,
} = cartSession.state;
export const cartVariantStatusAtom = cartSession.state.variantStatusAtom;
export const cartVariantStatusLookupAtom = cartSession.state.variantStatusLookupAtom;

/** One browser session owns this module and its permit. */
export const makeCartMutations = cartSession.mutations;
